import request from "../../Frontends/Common/utils/request/requestMain";
const _ = require("lodash");
const rootRoute = "/addressprogramarchived/kas/";

export default class KASApi {
  constructor() {
    this.defaultModel = {
    };
  }
  async getKASs(params) {
    return await request.post(`${rootRoute}getKASs`, {
      filter: params,
      parameters: {},
    });
  }
  async getKAS(id) {
    return await request.post(`${rootRoute}getKASs`, {
      filter: `$filter=Id eq ${id}`,
      parameters: {},
    });
  }
  async createKAS(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}createKAS`, { data });
  }
  async deleteKAS(model) {
    const data = [model];
    return await request.post(`${rootRoute}deleteKAS`, { data });
  }
  async editKAS(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateKAS`, { data });
  }
  async import(gfid) {
    return await request.post(`${rootRoute}importKAS`, {
      gfid: gfid
    });
  }
  async getImportScaffold() {
    return await request.post(`${rootRoute}getKASimporttemplate`, null, {responseType: 'blob'});
  }
  async export(filter, format) {
    return await request.post(`${rootRoute}exportKAS`, {
      filter: filter,
      format: format
    });
  }
}
